module.exports = __webpack_public_path__ + "static/princeton_shield-9fe2e2293e3e2b452feb6c6c691aa07b.png";